import { Workspace, WorkspaceStatus } from '@driftt/api-types'

export const DEFAULT_WORKSPACE: Workspace = {
  name: 'Default',
  id: 'default',
  status: WorkspaceStatus.ACTIVE,
  createdBy: -1,
  orgId: -1,
  updatedBy: -1,
}
